import Config from 'config';
import { Box } from '@apia/theme';
import { useAppSelector } from '../../../../../../hooks/hooks';
import useContext from '../../../../../../hooks/useContext';
import { ApiaComponentContextPrimitive } from '../../../apiaComponent/ApiaComponentContext';

const AppliedFiltersLabel = () => {
  const { fieldId } = useContext(ApiaComponentContextPrimitive);
  const { filters } = useAppSelector(
    (globalState) => globalState.querySlice.queries[fieldId],
  );

  const appliedFilters = filters?.filter(
    (currentFilter) =>
      currentFilter.apiaFilter.currentValue !==
      currentFilter.finderFilter?.defaultValue,
  );

  return appliedFilters && appliedFilters.length > 0 ? (
    <Box
      className="appliedFilters"
      sx={{
        marginTop: '7px',
        color: 'primary',
        display: 'block',
      }}
    >
      {Config.FINDER_APPLIED_FILTER}{' '}
      {appliedFilters.map((filter) => (
        <Box
          key={filter.apiaFilter.id}
          className="appliedFilter"
          sx={{ px: 1, display: 'inline-block' }}
        >
          {filter.apiaFilter.title}
        </Box>
      ))}
    </Box>
  ) : null;
};

export default AppliedFiltersLabel;
